export { grafferSchemasSuportTagNames } from "@graffer-inc/form-generator";
export const markdownHelpLink = "/help/contents/smartapply-fieldexplanation";
